export default __webpack_public_path__ + "static/media/bh4.b41683bd.webp";